import {AccountTypeEntityModel} from "../../account-type-entity.model";
import {EditService} from "../../../../framework/entity/edit/edit-page/edit.service";
import {Component} from "@angular/core";
import {AccountTypeData} from "../../account-type.data";

@Component({
    selector: "wbo-account-type-edit-other-settings",
    templateUrl: "./account-type-edit-other-settings.component.html"
})
export class AccountTypeEditOtherSettingsComponent {

    constructor(public model: AccountTypeEntityModel, public editService: EditService) {
    }

    get isSplitTenderReadonly(): boolean {
        return this.model.data.accountingType === AccountTypeData.OUTGOINGS;
    }

    get isMultipleContactsReadonly(): boolean {
        return this.model.data.accountingType === AccountTypeData.VOUCHER;
    }

    get isInvoicePrintCountReadonly(): boolean {
        return this.model.data.accountingType === AccountTypeData.OUTGOINGS;
    }
}
